import { I17INFPARCONSEP_State } from '@batical/types/src'

const I17INFPARCONSEP: I17INFPARCONSEP_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_rendElecModule: 34.33,
  in_rendThermiqueModule: 55.88,
  in_tarif: 49.0,
  mode: 'none',
  calcul_code: 'I17INFPARCONSEP',
  minData1: 0,
  maxData1: 0,
  lineData1: [],
  minData2: 0,
  maxData2: 0,
  lineData2: [],
  lineData1Web: [{ id: 'Prix C16', color: '#4277b9', data: [] }],
  lineData2Web: [{ id: 'Ep %', color: '#00A790', data: [] }]
}

export default I17INFPARCONSEP
